<template>

    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
    </teleport>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-10 flex justify-between">
                <Breadcrumbs :paths="paths"></Breadcrumbs>
                <div class="flex">
                    <NextButton variant="outline-secondary" @click="$router.back()"
                                class="w-44 hidden text-sm sm:block py-2 px-4">
                        &lt; Indietro
                    </NextButton>
                    <NextButton variant="primary" component="router-link" :to="{name: 'FormContatto'}"
                                class="w-44 ml-3 text-sm py-2 px-4 m-0 hidden sm:block">
                        + Aggiungi
                    </NextButton>
                </div>
            </div>
            <h3 class="text-3xl font-bold">Contatti</h3>

            <div class="flex overflow-x-auto md:grid md:grid-cols-3 lg:grid-cols-7 gap-3 py-4">
                <stato-card v-for="bu in businessUnits" :key="bu.id"
                            :sigla-progetto="bu.label"
                            :sigla-stato="getLabel(azienda.stati[bu.id])"
                            :progetto="bu.nome"
                            :stato="ENomiStato[azienda.stati[bu.id]] || ENomiStato[0]"
                            :colore-stato-class="`bg-next-${getColoriStati(azienda.stati[bu.id])}`">

                </stato-card>
            </div>

            <div v-for="gc in gruppi_contatti" :key="gc.id">
                <div class="mb-4 flex flex-shrink font-bold ">{{ gc.nome }}</div>
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4"
                               v-model:cols="contattiCols"
                               :rows="Contatti(gc.id)"
                    >
                        <template v-for="(c, j) in Contatti(gc.id)" :key="j" v-slot:[`td_${j}_5`]>
                            <router-link :to="{name:'DettaglioContatto', params:{id:c.cliente_id, cid:c.id}}"
                                         class="block text-center inset-0 absolute flex items-center justify-center">
                                <i class="icon-chevron_destra"></i>
                            </router-link>
                        </template>

                        <template v-for="(c, j) in Contatti(gc.id)" :key="j" v-slot:[`td_${j}_3`]>
                            <div v-show="c.telefono_1" class="flex justify-between items-center">
                                <span>{{ c.telefono_1 }}</span>
                                <NextButton component="a" :href="`tel:${c.telefono_1}`" variant="primary"
                                            class="w-10 px-3 py-1 flex items-center justify-center ml-3"><i
                                    class="icon-telefono"></i></NextButton>
                            </div>
                        </template>

                        <template v-for="(c, j) in Contatti(gc.id)" :key="j" v-slot:[`td_${j}_4`]>
                            <div v-show="c.email" class="flex justify-between items-center">
                                <span>{{ c.email }}</span>
                                <NextButton component="a" :href="`mailto:${c.email}`" variant="primary"
                                            class="w-10 px-3 py-1 flex items-center justify-center"><i
                                    class="icon-paper_plane"></i></NextButton>
                            </div>
                        </template>
                    </NextTable>

                </div>
            </div>
            <InfiniteLoading @infinite="fetchNextContattiPage" :identifier="infiniteIdentifier" style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altri contatti.</div>
                </template>
            </InfiniteLoading>
        </div>
    </div>

</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import ContattoCard from "@/components/ContattoCard.vue";
import Topbar from "@/components/Topbar.vue";
import StatoCard from "@/components/StatoCard.vue";
import {ColoriStati, LabelStati, NomiStato} from "@/types";
import businessUnitsManager from "../api/BusinessUnits";
import gruppiContattiManager from "../api/GruppiContatti";
import InfiniteLoading from "v3-infinite-loading";
import Loading from "@/components/Loading.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NextButton from "@/components/NextButton.vue";
import clientiManager from "../api/Clienti";
import NextTable from "@/components/NextTable.vue";

@Options({
    name: 'Contatti',
    components: {
        NextTable,
        Breadcrumbs,
        ContattoCard,
        StatoCard,
        Topbar,
        InfiniteLoading,
        NextButton,
        Loading
    },
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    }
})
export default class Contatti extends Vue {
    color = 'black'
    id!: string | number
    contatti_list: any[] = []
    azienda: any = {}
    gruppi_contatti: any[] = []
    businessUnits: never[] = []
    ENomiStato = NomiStato
    reparto = 1
    paginate_contatti: any = {}

    infiniteIdentifier = false
    loading = false

    get paths() {
        return [
            {
                title: 'Home',
                name: 'Dashboard',
            },
            {
                title: 'Anagrafica',
                name: 'DettaglioAzienda',
                params: {id: this.id ?? 0}
            },
            {
                title: 'Contatti',
                name: 'Contatti',
            },
        ]
    }

    getColoriStati(EnumStato: number | undefined) {
        if (EnumStato == undefined) {
            return ColoriStati[ColoriStati.neu]
        }
        return ColoriStati[EnumStato]
    }

    getLabel(EnumStato: number | undefined) {
        if (EnumStato == undefined) {
            return LabelStati[LabelStati.NEU]
        }
        return LabelStati[EnumStato]
    }

    fetchNextContattiPage(state: any) {
        if (this.paginate_contatti.current_page) {
            if (this.paginate_contatti.current_page < this.paginate_contatti.last_page) {
                this.loading = true
                this.fetchContatti(++this.paginate_contatti.current_page).then(() => {
                    state.loaded()
                }).catch(() => {
                    state.error()
                }).finally(() => {
                    this.loading = false
                })
            } else {
                state.complete()
            }
        } else {
            state.loaded()
        }
    }

    fetchContatti(page = 1) {
        return clientiManager.contattiAzienda(this.id, {page}).then((response) => {
            const {data, ...pag} = response.data;
            const dd = data.map((r: any) => {
                return {...r, tr_class: !r.presente ? 'bg-next-gray-md' : 'bg-next-gray-md-dark'}
            })
            if (page && page > 1) {
                this.contatti_list.push(...dd)
            } else {
                this.contatti_list.splice(0, this.contatti_list.length, ...dd)
            }
            this.paginate_contatti = pag
        })
    }

    created() {
        this.loading = true
        clientiManager.cliente(this.id).then((response) => {
            this.azienda = response.data
        }).then(() => {
            return Promise.all([
                businessUnitsManager.businessUnits({params:{crm: 1}}).then((response) => {
                    this.businessUnits = response.data
                }),
                gruppiContattiManager.gruppiContatti().then((response) => {
                    this.gruppi_contatti = response.data
                    return this.fetchContatti()
                })

            ])
        }).finally(() => {
            this.loading = false
        })
    }

    Contatti(id: number) {
        return this.contatti_list.filter((e) => {
            return e.gruppo_contatti_id == id
        })
    }

    IsEmpty(id: number) {
        return !this.Contatti(id).length
    }

    contattiCols = [
        {
            name: 'Nome',
            prop: 'nome',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 h-10',
            resizable: false
        },
        {
            name: 'Cognome',
            prop: 'cognome',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 h-10',
            resizable: false
        },
        {
            name: 'Posizione lavorativa',
            prop: 'posizione_lavorativa',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2',
            resizable: false
        },
        {
            name: 'Numero di telefono',
            prop: 'telefono_1',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2',
            resizable: false
        },
        {
            name: 'Email',
            prop: 'email',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2',
            resizable: false
        },
        {
            name: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white',
            resizable: false
        }
    ]

}
</script>


<style lang="scss">

</style>
